(function () {
  var ROOT_SELECTOR = "#tab_review #judgeme_product_reviews";
  var REVIEW_SELECTOR = ".jdgm-rev";
  var CLAMP_CLASS = "ko-review-clamped";
  var EXPANDED_CLASS = "ko-review-expanded";
  var TEXT_CLASS = "ko-review-text";
  var TOGGLE_CLASS = "ko-review-toggle";
  var CLAMP_REGION_CLASS = "ko-review-clamp-region";
  var HAS_REPLY_CLASS = "ko-review-has-reply";
  var INIT_ATTR = "data-ko-review-init";
  var resizeTimer;
  var delegationBound = false;
  var togglingUntil = 0;

  function isMobileView() {
    return window.matchMedia("(max-width: 767px)").matches;
  }

  function isToggling() {
    return Date.now() < togglingUntil;
  }

  function hasMerchantReply(review) {
    var reply = review.querySelector(".jdgm-rev__reply");
    if (!reply) return false;
    var replyContent = reply.querySelector(".jdgm-rev__reply-content");
    return !!(replyContent && replyContent.textContent.trim().length > 0);
  }

  function normalizeReviewLayout(review) {
    review.style.removeProperty("position");
    review.style.removeProperty("left");
    review.style.removeProperty("top");
    review.style.removeProperty("right");
    review.style.removeProperty("bottom");
    review.style.removeProperty("width");
    review.style.removeProperty("height");
    review.style.removeProperty("transform");
  }

  function setCollapsedState(review, clampTarget, button) {
    review.classList.remove("ko-review-open");
    clampTarget.classList.remove(EXPANDED_CLASS);
    clampTarget.classList.add(CLAMP_CLASS);
    if (button) {
      button.textContent = "Devamını oku";
      button.setAttribute("aria-expanded", "false");
    }
  }

  function setExpandedState(review, clampTarget, button) {
    review.classList.add("ko-review-open");
    clampTarget.classList.remove(CLAMP_CLASS);
    clampTarget.classList.add(EXPANDED_CLASS);
    if (button) {
      button.textContent = "Daha az göster";
      button.setAttribute("aria-expanded", "true");
    }
  }

  function needsClamp(clampTarget) {
    var text = (clampTarget.textContent || "").trim();
    if (text.length >= 120) return true;
    return clampTarget.scrollHeight > clampTarget.clientHeight + 2;
  }

  function getClampTarget(review) {
    return review.querySelector("." + CLAMP_REGION_CLASS);
  }

  function getToggleButton(review) {
    return review.querySelector("." + TOGGLE_CLASS);
  }

  function moveReplyIntoRegion(review, region) {
    var reply = review.querySelector(".jdgm-rev__reply");
    if (reply && reply.parentNode !== region) {
      region.appendChild(reply);
    }
  }

  function getOrCreateClampRegion(review) {
    var existing = getClampTarget(review);
    if (existing) {
      moveReplyIntoRegion(review, existing);
      return existing;
    }

    var content = review.querySelector(".jdgm-rev__content");
    var title = content && content.querySelector(".jdgm-rev__title");
    var body = content && content.querySelector(".jdgm-rev__body");
    var reply = review.querySelector(".jdgm-rev__reply");

    if (!title && !body && !reply) return null;

    var region = document.createElement("div");
    region.className = CLAMP_REGION_CLASS + " " + TEXT_CLASS;

    if (title) region.appendChild(title);
    if (body) region.appendChild(body);
    if (reply && reply.parentNode === review) region.appendChild(reply);

    var header = review.querySelector(".jdgm-rev__header");
    if (header) {
      header.insertAdjacentElement("afterend", region);
    } else if (content) {
      content.insertBefore(region, content.firstChild);
    } else {
      review.insertBefore(region, review.firstChild);
    }

    return region;
  }

  function placeToggleButton(review, button) {
    var actions = review.querySelector(".jdgm-rev__actions");
    if (actions && actions.parentNode === review) {
      actions.insertAdjacentElement("afterend", button);
      return;
    }

    var region = getClampTarget(review);
    if (region) {
      region.insertAdjacentElement("afterend", button);
      return;
    }

    review.appendChild(button);
  }

  function ensureToggleButton(review) {
    var button = getToggleButton(review);
    if (button) return button;

    button = document.createElement("button");
    button.type = "button";
    button.className = TOGGLE_CLASS;
    button.setAttribute("aria-expanded", "false");
    placeToggleButton(review, button);
    return button;
  }

  function clearToggle(review) {
    var button = getToggleButton(review);
    if (button) button.remove();

    var clampTarget = getClampTarget(review);
    if (clampTarget) {
      clampTarget.classList.remove(TEXT_CLASS, CLAMP_CLASS, EXPANDED_CLASS);
    }

    review.classList.remove("ko-review-open");
  }

  function applyClampState(review) {
    var clampTarget = getClampTarget(review);
    if (!clampTarget) {
      clearToggle(review);
      return;
    }

    clampTarget.classList.add(TEXT_CLASS);
    review.classList.toggle(HAS_REPLY_CLASS, hasMerchantReply(review));

    if (isMobileView()) {
      clearToggle(review);
      return;
    }

    var wasOpen = review.classList.contains("ko-review-open");
    clampTarget.classList.add(CLAMP_CLASS);

    if (!needsClamp(clampTarget)) {
      clearToggle(review);
      return;
    }

    var toggleButton = ensureToggleButton(review);

    if (wasOpen) {
      setExpandedState(review, clampTarget, toggleButton);
    } else {
      setCollapsedState(review, clampTarget, toggleButton);
    }
  }

  function setupReview(review) {
    normalizeReviewLayout(review);
    getOrCreateClampRegion(review);
    applyClampState(review);
    review.setAttribute(INIT_ATTR, "1");
  }

  function bindReview(review) {
    if (review.getAttribute(INIT_ATTR) === "1") {
      if (!isToggling()) {
        normalizeReviewLayout(review);
        applyClampState(review);
      }
      return;
    }

    setupReview(review);
  }

  function isKoManagedNode(node) {
    if (!node || node.nodeType !== 1) return false;
    if (node.classList && (node.classList.contains(TOGGLE_CLASS) || node.classList.contains(CLAMP_REGION_CLASS))) {
      return true;
    }
    return !!(node.closest && node.closest("." + CLAMP_REGION_CLASS));
  }

  function shouldIgnoreMutation(mutation) {
    if (isToggling()) return true;

    var nodes = [];
    if (mutation.addedNodes) nodes = nodes.concat(Array.prototype.slice.call(mutation.addedNodes));
    if (mutation.removedNodes) nodes = nodes.concat(Array.prototype.slice.call(mutation.removedNodes));

    if (!nodes.length) return false;

    return nodes.every(isKoManagedNode);
  }

  function handleToggleClick(event) {
    var button = event.target.closest("." + TOGGLE_CLASS);
    if (!button || !button.closest(ROOT_SELECTOR)) return;

    var review = button.closest(REVIEW_SELECTOR);
    if (!review) return;

    var clampTarget = getClampTarget(review);
    if (!clampTarget) return;

    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === "function") {
      event.stopImmediatePropagation();
    }

    togglingUntil = Date.now() + 600;

    if (clampTarget.classList.contains(EXPANDED_CLASS)) {
      setCollapsedState(review, clampTarget, button);
    } else {
      setExpandedState(review, clampTarget, button);
    }

    normalizeReviewLayout(review);
  }

  function bindDelegation() {
    if (delegationBound) return;
    delegationBound = true;
    document.addEventListener("click", handleToggleClick, true);
  }

  function getReviews(container) {
    return Array.prototype.slice.call(container.querySelectorAll(REVIEW_SELECTOR));
  }

  function processContainer(container) {
    var reviews = getReviews(container);
    if (!reviews.length) return;
    reviews.forEach(bindReview);
  }

  function refreshReviews() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(processContainer);
  }

  function scheduleRefresh() {
    if (isToggling()) return;
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(refreshReviews, 250);
  }

  function watchContainers() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(function (container) {
      if (container.dataset.koReviewObserverBound === "1") return;
      container.dataset.koReviewObserverBound = "1";

      var layoutTimer;

      var observer = new MutationObserver(function (mutations) {
        if (isToggling()) return;

        var shouldRefresh = false;
        var shouldNormalize = false;

        mutations.forEach(function (mutation) {
          if (shouldIgnoreMutation(mutation)) return;

          if (mutation.type === "childList" && (mutation.addedNodes.length || mutation.removedNodes.length)) {
            shouldRefresh = true;
          }

          if (
            mutation.type === "attributes"
            && mutation.attributeName === "style"
            && mutation.target
            && mutation.target.matches
            && mutation.target.matches(REVIEW_SELECTOR)
          ) {
            shouldNormalize = true;
          }
        });

        if (shouldNormalize) {
          window.clearTimeout(layoutTimer);
          layoutTimer = window.setTimeout(function () {
            if (isToggling()) return;
            getReviews(container).forEach(normalizeReviewLayout);
          }, 30);
        }

        if (shouldRefresh) scheduleRefresh();
      });

      observer.observe(container, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ["style"],
      });
    });
  }

  function init() {
    bindDelegation();
    refreshReviews();
    watchContainers();
  }

  document.addEventListener("click", function (event) {
    var tabTrigger = event.target.closest && event.target.closest('a[href="#tab_review"]');
    if (!tabTrigger) return;
    window.setTimeout(function () {
      init();
      window.setTimeout(refreshReviews, 500);
    }, 200);
  });

  window.addEventListener("resize", scheduleRefresh);
  document.addEventListener("DOMContentLoaded", init);
  window.setTimeout(init, 600);
})();
